<template>
  <v-row>
    <v-col class="mt-2" cols="12" lg="7" offset-lg="1">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-tabs
        py-2
        v-model="tabModel"
        height="60px"
        slider-color="white"
        background-color="#551738"
      >
        <v-tab :to="{ name: 'AddPension' }" :ripple="false" class="white--text">
          <v-icon small class="white--text mr-2">money</v-icon>
          Pension
        </v-tab>
        <v-tab href="#insurance" :ripple="false" class="white--text">
          <v-icon small class="white--text mr-2">medical_services</v-icon>
          Insurance
        </v-tab>
        <v-tab
          :to="{ name: 'AddCustomBenefit' }"
          :ripple="false"
          class="white--text"
        >
          <v-icon small class="white--text mr-2">shuffle</v-icon>
          Custom
        </v-tab>
        <v-spacer />
        <v-btn
          depressed
          class="error white--text mt-3 mr-2 rounded-sm"
          @click="deleteDialog = true"
          >Delete
        </v-btn>
      </v-tabs>

      <v-tabs-items v-model="tabModel">
        <v-tab-item :value="'insurance'">
          <v-divider />
          <v-card>
            <v-card-text>
              <v-form ref="form" valid="valid">
                <v-row>
                  <v-col cols="12" lg="7">

                    <v-text-field
                        label="Title *"
                        validate-on-blur
                        :rules="[validationRules.required]"
                        clearable
                        v-model="benefit.title"
                    />

                    <v-text-field
                        label="Subheading *"
                        validate-on-blur
                        :rules="[validationRules.required]"
                        clearable
                        v-model="benefit.name"
                    />

                    <v-text-field
                        :rules="[validationRules.required]"
                        label="Provider name"
                        validate-on-blur
                        clearable
                        hint="Name of the company that offers this benefit"
                        v-model="benefit.provider_name"
                    />

                    <v-select
                        label="Location*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        :items="countries"
                        item-text="name"
                        item-value="name"
                        v-model="benefit.location"
                    />


                    <v-textarea
                        label="Benefit details*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        v-model="benefit.information"
                    />

                    <v-file-input
                        v-model="fileInput"
                        show-size
                        label="Upload an image or logo"
                        accept="image/*"
                    ></v-file-input>

                    <v-select
                        label="Status*"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        persistent-hint
                        hint="Only active benefits will be visible to employees"
                        :items="statuses"
                        item-text="name"
                        item-value="name"
                        v-model="benefit.status"
                    />

                   <!-- <v-text-field
                        label="Cost *"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        hint="Annual cost of this benefit per employee"
                        v-model="benefit.cost"
                        class="mt-4"
                    />

                    <v-text-field
                        label="Currency *"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                        v-model="benefit.currency"
                    />-->
                  </v-col>
                  <v-col cols="12" lg="5"/>
                </v-row>
                <v-btn depressed class="save white--text ml-0 mt-3" @click="save">Save</v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-col>

    <v-col class="px-1 pa-3" cols="12" lg="3">
      <v-card class="mt-16 mb-3">
        <v-card-text>
          <div class="subheading font-weight-medium text-capitalize">
            Save on insurance now !!
          </div>
          <div class="grey--text text--darken-1 mt-2 font-weight-medium">
            Thanks to all you members of LessAdmin, we’ve managed to negotiate a
            special deal on insurance exclusively for members of the community.
          </div>
          <div class="grey--text mt-2">
            When clicking the button below, our insurance partner XX will get in
            touch
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="ml-2 action white--text rounded-sm">Yes. Give me an offer</v-btn>
        </v-card-actions>
        <v-card-text>
          <div class="subheading mt-2">Why does insurance matter?</div>
          <div class="grey--text text--darken-1 mt-1">
            If you have employees you need to offer a Insurance plan. This can
            be a great benefit. We've done it easy to understand.
          </div>
        </v-card-text>
      </v-card>

      <v-card class="mt-2 mb-3">
        <v-card-text>
          <div class="subheading font-weight-medium text-capitalize">
            Become a benefit provider !
          </div>
          <div class="grey--text text--darken-1 mt-2">
            Contribute to the community by offering your products and services to other users and companies.
            We only ask that you give back in the form of a unique offer or discount.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="rounded-sm white--text action ml-2" depressed
                 @click="manageOfferings"
          >Manage your offers
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card class="mt-2">
        <v-card-text>
          <div class="subheading font-weight-medium">
            Insurance plan preview
          </div>
          <div class="grey--text mt-1">
            Add details in the form to for live preview
          </div>
        </v-card-text>
        <v-img height="240" v-if="benefit.url" :src="benefit.url"/>
        <v-card-text primary-title>
          <div v-if="benefit">
            <h2>{{ benefit.name }}</h2>
            <div class="subheading mb-2">{{ benefit.title }}</div>
            <!--<div class="body-2  mb-1">
              Cost : {{ benefit.cost }} {{ benefit.currency }} / {{ benefit.unit }}
            </div>-->
            <div class="body-2  mb-1">
              Provider : {{ benefit.provider_name }}
            </div>
            <div class="body-2  mb-1">
              Category : {{ benefit.category }}
            </div>
            <div class="body-2  mb-1">
              Location :
              {{ benefit.sub_location ? benefit.sub_location + ', ' : '' }}
              {{ benefit.location ? benefit.location : '' }}
            </div>
          </div>
          <div>
            <div class="subheading grey--text mt-4 text--darken-1">
              {{ benefit.information }}
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="deleteDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline pt-4">
          <v-spacer/>
          <span>Are you sure?</span>
          <v-spacer/>
        </v-card-title>
        <v-divider/>
        <v-card-text class="my-2 text-xs-center">
          This benefit will be deleted. You cannot recover this operation
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-btn color="success" text @click="deleteDialog = !deleteDialog">cancel</v-btn>
          <v-spacer/>
          <v-btn color="error" text @click="deleteEntity">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import {mapGetters}  from 'vuex';

import {Actions}     from '@/views/actions';
import {Breadcrumbs} from '@/views/breadcrumbs';
import {Component}   from '@/views/component';
import {Constants}   from '@/views/constants';

export default {
  name: Component.Protected.Benefit.Insurance.Edit,
  data: () => ({
    tabModel: 'insurance',
    endDateModal: false,
    startDateModal: false,
    id: '',
    breadcrumbs: Breadcrumbs.Benefit.Insurance.Edit,
    benefit: null,
    statuses: Constants.Benefits.Status.Obj,
    valid: false,
    deleteDialog: false,
    fileInput: [],
  }),
  computed: {
    ...mapGetters(["countries", "userInfo", "companyInfo"]),
  },
  methods: {
    manageOfferings() {
      this.$router.push({name: Component.Protected.Benefit.Provider.Info});
    },
    init() {
      this.benefit = {
        //cost: '',
        //unit: Constants.Benefits.Unit.Person,
        location: this.companyInfo.location,
        sub_location: '',
        information: '',
        name: '',
        provider_id: null,
        provider_name: '',
        status: Constants.Benefits.Status.Active,
        title: 'Insurance Plan',
        type: Constants.Benefits.Type.B2C,
        url: '',
        category: Constants.Benefits.Category.Insurance,
        //currency: '',
      };
      this.deleteDialog = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        //Logo is uploaded
        if (this.fileInput != ""){
        const fileName = `company/${this.userInfo.namespace}/benefit/${this.fileInput.name.replaceAll(" ", "_")}`
        const data = {
          action: 'editBenefit',
          fileName: fileName,
          metadata: {
            customMetadata: {
              namespace: this.userInfo.namespace,
              uid: this.userInfo.uid,
              type: "image",
            },
          },
          payload: {...this.benefit, cost: parseFloat(this.benefit.cost), url: ""},
          id: this.$route.params.id,
          content: this.fileInput,
        };

        this.$store
          .dispatch(Actions.Firebase.UploadImage, data)
          .then(() => {
            this.$router.push({name: Component.Protected.Benefit.List});
          })
          .catch((err) => {
            console.error(Constants.Benefits.Messages.Error.Edit, err);
            this.snackbar = true;
            this.snackbarMessage = Constants.Benefits.Messages.Error.Edit;
          })
          .finally(() => {
            this.fileInput = null;
          });
          return;
        }
        //Log is not uploaded
        const data = {
          id: this.$route.params.id,
          data: {...this.benefit, cost: parseFloat(this.benefit.cost)}
        };
        this.$store.dispatch(Actions.Benefits.Edit, data).then(() => {
          this.$router.push({name: Component.Protected.Benefit.List});
        }).catch((err) => {
          console.error(Constants.Benefits.Messages.Error.Edit, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.Benefits.Messages.Error.Edit;
        });
      }
    },
    deleteEntity() {
      if (!this.$route.params.id || this.userInfo.role !== Constants.Roles.HR) {
        return false;
      }
      this.deleteDialog = false;
      this.$store
        .dispatch(Actions.Benefits.Delete, this.$route.params.id)
        .then(() => {
          this.$router.push({ name: Component.Protected.Benefit.List });
        })
        .catch((err) => {
          console.error(Constants.Benefits.Messages.Error.Delete, err);
          this.snackbarMessage = Constants.Benefits.Messages.Error.Delete;
          this.snackbar = true;
        });
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR || !this.$route.params.id) {
        this.$router.push({ name: Component.Protected.Benefit.List });
      }
      this.init();
      this.getBenefit();
    },
    getBenefit() {
      this.$store.dispatch(Actions.Benefits.Get, this.$route.params.id).then((r) => {
        if (r.status === 200) {
          if (!r.data) {
            this.$router.push({name: Component.Protected.Benefit.List});
            return false;
          }
          this.benefit = r.data;
        }
      }).catch((err) => {
        console.error(Constants.Benefits.Messages.Error.Get, err);
        this.snackbar = true;
        this.snackbarMessage = Constants.Benefits.Messages.Error.Get;
      });
    },
  },
  created() {
    if (this.userInfo && this.companyInfo && this.countries) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>
<style scoped>
* >>> div.v-tabs__container {
  height: 60px !important;
  padding-left: 10px;
}

* >>> div.v-picker__title {
  background-color: #551738 !important;
  border-color: #551738 !important;
}

* >>> div.v-date-picker-table {
  height: 200px !important;
}

* >>> div.v-item-group {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
</style>